import { createFileRoute, Outlet } from '@tanstack/react-router'

/** Authenticated workspace-entry layout. */
export const Route = createFileRoute('/_ws/workspaces')({
  component: () => <Outlet />,
})
